import { useEffect, useMemo, useState } from "react";
import { getVipInfo } from "../../api";
import Navigator from "../../component/navigator";
import { VipInfo } from "../../types";
import headerBg1Img from "./images/bg-1.png";
import styles from "./index.module.scss";
import cn from "classnames";
import FooterButton from "./footer-button";
import { Loading, Modal } from "@quark/design";
import RightIcon from "./right-icon";
import { login } from "../../utils";
import useDocumentTitle from "../../hooks/use-document-title";
import UserProfile from "./components/user-profile";
import MembershipTabs from "./components/membership-tabs";
import { useNavigate } from "react-router-dom";
import useProfile from "../../hooks/use-profile.ts";
import { LOGIN_EVENT } from "../../constants";
import tracker from "@quark/tracker";

type VipType = "none" | "vip" | "update";
// 001: 年费，002: 终身，003: 升级
export type VipCode = "001" | "002" | "003";

const questions = [
  {
    q: "报名VIP后如何学习？",
    a: "报名VIP后，全部课程及题库立即开通，随时可学，平台、手机、电脑均支持。",
  },
  {
    q: "有专业1 v 1答疑老师吗？",
    a: "VIP学员添加专业老师后，有任何问题均可1v1私信，享有优先答疑权益。",
  },
  {
    q: "后续新增课程自动可学吗？",
    a: "vip会员用户，后续新课程均自动添加，无需再次购买。",
  },
  {
    q: "VIP 会过期吗？",
    a: "当前年费VIP买1年送1年，终身VIP 永久生效。",
  },
  {
    q: "VIP价格会变化吗？",
    a: "随着新增功能服务和课程的增加，VIP价格也会随之浮动，已开通的VIP权益无影响。",
  },
  {
    q: "开通VIP之后可以退款吗？",
    a: "VIP服务为虚拟服务，购买成功后立即生效，暂不接受退款，敬请谅解！",
  },
];

const VipPage = () => {
  const [vipInfo, setVipInfo] = useState<VipInfo>();
  const [loading, setLoading] = useState(false);
  const [purchaseVisible, setPurchaseVisible] = useState(false);
  const [modalDefaultTab, setModalDefaultTab] = useState<"one" | "forever">();
  const userInfo = useProfile();
  const navigate = useNavigate();
  const vipType = useMemo<VipType>(() => {
    if (!vipInfo) return "none";
    if (vipInfo.vip_infos.length) return "vip";
    if (vipInfo.has_course) return "update";
    return "none";
  }, [vipInfo]);

  useEffect(() => {
    if (!userInfo) {
      return;
    }
    // if (!userInfo.is_login) {
    //   window.dispatchEvent(new Event(LOGIN_EVENT));
    // }
  }, [userInfo]);

  const isVip = useMemo(() => vipType === "vip", [vipType]);
  const hasCourse = useMemo(() => !!vipInfo?.has_course, [vipInfo]);

  useDocumentTitle("开通会员");

  const updateVipInfo = () => {
    setLoading(true);
    getVipInfo()
      .then((data) => {
        setVipInfo(data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenVipModal = (tab: "one" | "forever") => {
    if (!userInfo?.is_login) {
      window.dispatchEvent(new Event(LOGIN_EVENT));
      return;
    }
    window._hmt.push(["_trackEvent", "vip", "open_vip_purchase_modal"]);
    tracker.sendEvent("pcVipShowPurchaseModal", {});
    setPurchaseVisible(true);
    setModalDefaultTab(tab);
  };

  const handleCloseVipModal = () => {
    setPurchaseVisible(false);
    setLoading(true);
    window._hmt.push(["_trackEvent", "vip", "hide_vip_purchase_modal"]);
    getVipInfo()
      .then((info) => {
        if (info.vip_infos?.length > 0) {
          window._hmt.push(["_trackEvent", "vip", "buy_vip_success"]);
          navigate("/course/list");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    updateVipInfo();
    tracker.sendEvent("pcVipShowPage", {});
  }, []);

  return (
    <>
      <Navigator activeKey="vip" />

      {loading && <Loading />}

      {vipInfo && !loading && (
        <>
          <div className={styles.header}>
            <img className={styles.bg1} src={headerBg1Img} alt="" />
            <div className={styles.headerContent}>
              <img
                className={styles.headerContentImg}
                src="https://python2fun.oss-cn-beijing.aliyuncs.com/probleamset/6026bbf308a00eac3f91ae901.png"
                alt=""
              />
              <div className={styles.headerInfo}>
                <div className={styles.sellingTitle}>会员权益专享</div>
                <div className={styles.sellingPoint}>4大学习方向</div>
                <div className={styles.sellingPoint}>20+门精品好课</div>
                <div className={styles.sellingPoint}>1000+节交互学习</div>
                <div className={styles.sellingPoint}>1000+道在线挑战</div>
                <div className={styles.sellingPoint}>5000+元课程价值</div>
                <div className={styles.sellingPoint}>1v1专属答疑</div>

                {vipType === "none" && (
                  <div
                    className={styles.button}
                    onClick={() => handleOpenVipModal("one")}
                  >
                    开通会员
                    <div className={styles.badge}>
                      低至 <span className={styles.num}>0.68</span>
                      元/天
                    </div>
                  </div>
                )}

                {vipType === "update" && (
                  <div
                    className={styles.button}
                    onClick={() => handleOpenVipModal("one")}
                  >
                    升级成为会员
                    <div className={styles.badge}>
                      仅需 <span className={styles.num}>299</span>元
                    </div>
                  </div>
                )}

                {vipType === "vip" && (
                  <div className={styles.button}>
                    你已是VIP会员
                    <div className={styles.badge}>
                      已省 <span className={styles.num}>5000+</span>元
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={styles.container}>
            <div className={styles.privilege}>
              <img
                src="https://python2fun.oss-cn-beijing.aliyuncs.com/probleamset/6026bbf308a00eac3f91ae900.png"
                alt=""
              />
            </div>

            <div className={styles.cards}>
              <div className={styles.title}>VIP权益对比</div>
              <div className={styles.content}>
                <div className={cn(styles.card, styles.normalCard)}>
                  <div className={styles.name}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="36"
                      viewBox="0 0 35 36"
                      fill="none"
                    >
                      <path
                        d="M17.5 0.5L32.6554 9.25V26.75L17.5 35.5L2.34456 26.75V9.25L17.5 0.5Z"
                        fill="#DDDDDD"
                      />
                      <path
                        d="M17 16.4818C14.9323 16.4818 13.25 14.7995 13.25 12.7318C13.25 10.664 14.9323 8.9818 17 8.9818C19.0678 8.9818 20.75 10.664 20.75 12.7318C20.75 14.7995 19.0678 16.4818 17 16.4818ZM17 10.4818C15.7593 10.4818 14.75 11.4911 14.75 12.7318C14.75 13.9725 15.7593 14.9818 17 14.9818C18.2407 14.9818 19.25 13.9725 19.25 12.7318C19.25 11.4911 18.2407 10.4818 17 10.4818ZM15.6617 26.4046C13.3978 26.4046 11.3274 26.3154 10.2415 25.2337C9.76503 24.7591 9.52344 24.1445 9.52344 23.4071C9.52344 22.6658 9.7636 21.9349 10.2373 21.2347C10.6586 20.6119 11.2429 20.0455 11.9739 19.5511C13.4201 18.5733 15.252 18.0124 17 18.0124C18.7473 18.0124 20.5754 18.5736 22.0157 19.5521C22.7434 20.0465 23.3249 20.6131 23.7441 21.2364C24.2146 21.936 24.4531 22.6663 24.4531 23.4071C24.4531 24.1466 24.2113 24.7624 23.7344 25.2375C22.5458 26.4215 20.1761 26.4123 17.6669 26.4028C17.2223 26.4011 16.7777 26.4011 16.333 26.4028C16.1079 26.4037 15.8839 26.4046 15.6617 26.4046ZM17 24.9011C17.2242 24.9011 17.4488 24.902 17.6727 24.9028C18.8333 24.9073 19.9293 24.9115 20.8557 24.7998C21.7561 24.6912 22.3685 24.4809 22.6758 24.1748C22.7949 24.0562 22.9531 23.8476 22.9531 23.4071C22.9531 22.5143 22.3042 21.5615 21.1727 20.7928C19.975 19.9791 18.4541 19.5124 17 19.5124C14.0396 19.5124 11.0234 21.4779 11.0234 23.4071C11.0234 23.8448 11.1814 24.0527 11.3002 24.171C12.0512 24.9192 14.323 24.9105 16.3273 24.9028C16.5513 24.902 16.7759 24.9011 17 24.9011Z"
                        fill="white"
                      />
                    </svg>
                    普通学员
                  </div>
                  <div className={styles.desc}></div>
                  <div className={styles.price}>注册即可</div>
                  {!isVip && (
                    <div className={styles.button} onClick={login}>
                      点击登陆注册
                    </div>
                  )}
                  <div className={styles.divider}></div>
                  <div className={styles.item}>
                    课程单独付费
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    仅可学习已够课程
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    少量习题
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    答疑
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    无积分
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    已够课程证书
                    <RightIcon color="#9E9E9E" />
                  </div>
                </div>

                <div className={cn(styles.card, styles.vipCard)}>
                  <div className={styles.badge}>
                    <span className={styles.hl}>限时福利</span>
                    <span>买一年送一年</span>
                  </div>
                  <div className={styles.name}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="36"
                      viewBox="0 0 35 36"
                      fill="none"
                    >
                      <path
                        d="M17.5 0.5L32.6554 9.25V26.75L17.5 35.5L2.34456 26.75V9.25L17.5 0.5Z"
                        fill="#FFA900"
                      />
                      <path
                        d="M12.8752 15.4556C13.2732 15.5523 13.6899 15.3964 13.9268 15.0623L17.0531 10.6538L20.6676 15.1135C20.9221 15.4276 21.3407 15.5575 21.7284 15.4427L25.5992 14.2964L22.8884 25H11.1093L8.38227 14.3647L12.8752 15.4556ZM17.0106 9.33076L16.4341 9.79803L16.4341 9.79802L17.0106 9.33076Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinejoin="round"
                      />
                    </svg>
                    年费VIP
                  </div>
                  <div className={styles.desc}>包含20+VIP分类，价值5000+元</div>
                  <div className={styles.price}>
                    ￥
                    <span style={{ fontSize: 32, fontWeight: "bold" }}>
                      499
                    </span>
                    元/2年
                    <span
                      style={{ textDecoration: "line-through", marginLeft: 20 }}
                    >
                      原价998元
                    </span>
                  </div>
                  {!isVip && (
                    <div
                      className={styles.button}
                      onClick={() => handleOpenVipModal("one")}
                    >
                      立即购买
                    </div>
                  )}
                  <div className={styles.divider}></div>
                  <div className={styles.item} style={{ color: "#DC985E" }}>
                    立省5000+元
                    <RightIcon color="#DC985E" />
                  </div>
                  <div className={styles.item}>
                    买多久学多久
                    <RightIcon />
                  </div>
                  <div className={styles.item}>
                    全部习题
                    <RightIcon />
                  </div>
                  <div className={styles.item}>
                    专属 1v1 老师
                    <RightIcon />
                  </div>
                  <div className={styles.item}>
                    学习积分奖励
                    <RightIcon />
                  </div>
                  <div className={styles.item}>
                    全部课程证书
                    <RightIcon />
                  </div>
                </div>

                <div className={cn(styles.card, styles.svipCard)}>
                  <div className={styles.name}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="36"
                      viewBox="0 0 35 36"
                      fill="none"
                    >
                      <path
                        d="M17.5 0.5L32.6554 9.25V26.75L17.5 35.5L2.34456 26.75V9.25L17.5 0.5Z"
                        fill="#FFA900"
                      />
                      <path
                        d="M7.08272 13.3226C7.04524 13.1764 7.17699 13.043 7.32365 13.0786L13.1111 14.4839L16.8475 9.21507C16.9241 9.10705 17.0826 9.10195 17.166 9.20483L21.4444 14.4839L26.6631 12.9385C26.8117 12.8945 26.9518 13.029 26.9137 13.1794L23.6667 26H10.3333L7.08272 13.3226Z"
                        fill="white"
                      />
                    </svg>
                    终身VIP
                  </div>
                  <div className={styles.desc}>
                    包含20+VIP分类，未来持续新增
                  </div>
                  <div className={styles.price}>
                    ￥
                    <span style={{ fontSize: 32, fontWeight: "bold" }}>
                      899
                    </span>
                    元/终身
                    <span
                      style={{ textDecoration: "line-through", marginLeft: 20 }}
                    >
                      原价1798元
                    </span>
                  </div>
                  {!isVip && (
                    <div
                      className={styles.button}
                      onClick={() => handleOpenVipModal("forever")}
                    >
                      立即购买
                    </div>
                  )}
                  <div className={styles.divider}></div>
                  <div className={styles.item} style={{ color: "#DC985E" }}>
                    一次付费
                    <RightIcon color="#DC985E" />
                  </div>
                  <div className={styles.item} style={{ color: "#DC985E" }}>
                    终身学习
                    <RightIcon color="#DC985E" />
                  </div>
                  <div className={styles.item}>
                    全部习题
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    专属 1v1 老师
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    学习积分奖励
                    <RightIcon color="#9E9E9E" />
                  </div>
                  <div className={styles.item}>
                    全部课程证书
                    <RightIcon color="#9E9E9E" />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.courseList}>
              <div className={styles.title}>4大类别Python课程免费学</div>

              <div className={styles.courseType}>
                {vipInfo.course_list.map(({ cate, courses }) => {
                  return (
                    <div className={styles.courseItem} key={cate}>
                      <div className={styles.courseTitle}>{cate}</div>
                      <div className={styles.courses}>
                        {courses.map((course) => {
                          return (
                            <div className={styles.course} key={course.title}>
                              <img src={course.cover} alt="" />
                              <div className={styles.title}>{course.title}</div>
                              <div className={styles.footer}>
                                <span className={styles.tip}>会员免费</span>
                                <span className={styles.price}>
                                  ￥{course.price}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={styles.users}>
              <img
                src="https://python2fun.oss-cn-beijing.aliyuncs.com/probleamset/6026bbf308a00eac3f91ae902.png"
                alt=""
              />
            </div>

            <div className={styles.questions}>
              <div className={styles.title}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_3972_9606)">
                    <path
                      d="M12 0.000244141C5.37451 0.000244141 0 5.3689 0 11.9944C0 18.626 5.37451 24.0005 12 24.0005C18.6299 24.0005 24 18.626 24 11.9944C24 5.3686 18.6299 0.000244141 12 0.000244141ZM12 19.9877C11.2441 19.9877 10.6321 19.3757 10.6321 18.6199C10.6321 17.864 11.2456 17.252 12 17.252C12.7544 17.252 13.3679 17.864 13.3679 18.6199C13.3679 19.3757 12.7559 19.9877 12 19.9877ZM14.4343 12.5926C13.7353 13.0517 13.4997 13.5796 13.4997 14.1407V16.5002H10.7906H10.4997V13.1417C10.4997 12.2252 10.9078 11.6027 11.7823 11.0416L13.3872 10.023C14.3411 9.36763 14.2617 8.04751 13.6617 7.46245C13.1367 6.95093 12.1046 6.65532 11.1642 6.84604C9.43916 7.19409 8.99971 8.46763 8.99971 9.67495V10.5H6.94482C6.94482 7.49995 7.19678 7.05903 8.3833 5.76147C9.70488 4.31099 11.5737 3.92837 13.2943 4.28403C15.0149 4.6397 17.0684 6.31958 17.0684 8.76294C17.0684 11.2066 15.1333 12.1353 14.4343 12.5926Z"
                      fill="#E6B573"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3972_9606">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                常见问题
              </div>
              <div className={styles.content}>
                {questions.map(({ q, a }, index) => {
                  return (
                    <div className={styles.question} key={q}>
                      <div className={styles.q}>
                        {index + 1}、{q}
                      </div>
                      <div className={styles.a}>{a}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {vipType !== "vip" && (
              <div className={styles.pageFooter}>
                <span style={{ fontSize: "1.5em", marginRight: 30 }}>
                  加入PythonTip VIP
                </span>
                <span>每天一小步，助力提升编程专业技能</span>
                <FooterButton
                  className={styles.button}
                  onClick={() => handleOpenVipModal("one")}
                >
                  开通 VIP
                </FooterButton>
              </div>
            )}
          </div>
        </>
      )}

      {vipInfo && (
        <Modal
          title={
            <div className={styles.modalTitle}>
              <UserProfile />
            </div>
          }
          className={styles.vipPurchaseModal}
          mainClassName={styles.modalMain}
          contentClassName={styles.modalBody}
          visible={purchaseVisible}
          onClose={handleCloseVipModal}
        >
          {purchaseVisible && (
            <div className={styles.container}>
              <MembershipTabs
                hasCourse={hasCourse}
                defaultTab={modalDefaultTab}
              />
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default VipPage;
